<template>
    <div
        class="card rounded-0 shadow-sm px-0"
        :class="{ 'col-2': show }"
        style="height: fit-content; cursor: pointer;"
    >
        <ul class="list-group list-group-flush">
            <li
                @click="setResource(null)"
                :class="{
                    'list-group-item-secondary': !staff
                }"
                class="list-group-item rounded-0 text-dark"
            >
                <span v-if="show">All Columns</span>
                <b-button
                    @click="toggleStaff"
                    class="float-right"
                    variant="link"
                    style="margin: -0.4rem -0.9rem;"
                >
                    <i
                        :class="{
                            'fa-angle-double-left': show,
                            'fa-angle-double-right': !show
                        }"
                        aria-hidden="true"
                        data-hidden="true"
                        class="fa fa-angle-double-left"
                    ></i>
                </b-button>
            </li>
            <li
                v-for="resource in resources"
                :class="{
                    'list-group-item-secondary': compareId(resource)
                }"
                :key="resource.id"
                @click="setResource(resource)"
                class="list-group-item rounded-0 text-dark p-3"
            >
                {{ show ? resource.title : resource.initial }}
            </li>
        </ul>
    </div>
</template>
<script>
export default {
    computed: {
        staff: {
            get() {
                return (
                    this.$store.state?.userPreferences?.prefs?.calendar?.selectedResource ?? null // prettier-ignore
                );
            },
            set(value) {
                return this.$store.commit(
                    "userPreferences/setCalendarAppointmentPref",
                    {
                        selectedResource: value
                    }
                );
            }
        }
    },
    props: {
        show: {
            type: Boolean,
            default() {
                return window.localStorage.getItem("appointment-hide-side-menu")
                    ? false
                    : true;
            }
        },
        resources: {
            type: Array,
            default() {
                return [];
            }
        },
        value: String
    },
    mounted() {
        this.$emit("update:show");
    },
    methods: {
        compareId(resource) {
            return resource?.id === this.staff?.id;
        },
        toggleStaff() {
            let show = true;
            if (this.show === false) {
                show = true;
            } else {
                show = false;
            }
            this.$emit("update:show", show);
            this.$emit("toggle-show-staff", show);
        },
        setResource(staff) {
            this.staff = staff;
            this.$emit("select", staff);
        }
    }
};
</script>
